module.exports = __webpack_public_path__ + "static/media/waterpark.05935dec.MP4";